import { createContext } from 'react';

import { Token, UserInformation } from '../../interfaces';

/*
 * Aquí ira toda se recibirá y almacenara toda la información del productor logueado.
 */
interface AuthContextProps {
  fetchTokens:    () => Promise<void>;
  getUserInfo:    () => UserInformation | null;
  logout:         () => null;
  login:          (user: string, pass: string) => Promise<boolean>;
  token?:         Token;
  Productores?:    Token;
  updateUserInfo: (userInfo: UserInformation) => void;
  userInfo:       UserInformation | null;
  isLoadingLogin: boolean;
}

export const AuthContext = createContext({} as AuthContextProps);
